import React from "react";
import { Input, Label } from "reactstrap";
import { ErrorMessage } from "formik";

// const FormikInputField = ({
//   field: { ...fields },
//   form: { touched, errors, setFieldValue, handleBlur },
//   ...props
// }) => {
//   const { label, id } = props;
//   const { name } = fields;

//   const handleChange = (e) => {
//     const { value } = e.target;
//     setFieldValue(name, value, true);
//   };

//   return (
//     <>
//       {label && (
//         <Label for={id} className="label-color">
//           {label}
//         </Label>
//       )}
//       <Input
//         onChange={handleChange}
//         invalid={Boolean(touched[name] && errors[name])}
//         onBlur={handleBlur}
//         {...props}
//         {...fields}
//       />

//       <ErrorMessage
//         name={name}
//         render={(msg) => {
//           return <div className="text-danger font-size-12">{msg}</div>;
//         }}
//       />
//     </>
//   );
// };
// export default FormikInputField;



const FormikInputField = ({
  field: { ...fields },
  form: { touched, errors, setFieldValue, handleBlur },
  ...props
}) => {
  const { label, id, onChange } = props;
  const { name } = fields;

  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue(name, value, true);
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <>
      {label && (
        <Label for={id} className="label-color">
          {label}
        </Label>
      )}
      <Input
        {...fields}
        {...props}
        onChange={handleChange} 
        onBlur={handleBlur}
        invalid={Boolean(touched[name] && errors[name])}
      />
      <ErrorMessage
        name={name}
        render={(msg) => (
          <div className="text-danger font-size-12">{msg}</div>
        )}
      />
    </>
  );
};


export default FormikInputField;

